export default __webpack_public_path__ + "static/bar-chart-d0489cbcebe355fafa4b10018d5f6bb1.svg";